import { render, staticRenderFns } from "./ChangeMargin.vue?vue&type=template&id=302704c6&scoped=true"
import script from "./ChangeMargin.vue?vue&type=script&lang=js"
export * from "./ChangeMargin.vue?vue&type=script&lang=js"
import style0 from "./ChangeMargin.vue?vue&type=style&index=0&id=302704c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "302704c6",
  null
  
)

export default component.exports